module.exports = __webpack_public_path__ + "static/media/PersonalColumbia.72d439a1.webp";